import React from 'react';
import { SVGIcon } from '@superops/super-icons';
import { isEmpty } from 'lodash';

function AssetIconCell(props) {
  const { cell, iconSize } = props;
  const { row } = cell;
  const iconMap = {
    1: 'Windows',
    2: 'LinuxIcon',
    3: 'Mac',
    4: 'Printer',
    5: 'Router',
    6: 'Switch',
    7: 'FireWall',
    8: 'UPS',
    9: 'LoadBalancer',
    10: 'PowerDevice',
    11: 'Storage',
    12: 'Wan',
    13: 'WireLessAccessPointNew',
    14: 'WirelessLanControllerNew',
    15: 'Voip',
    16: 'IpCamera',
    17: 'Storage',
    18: 'ServerHardwareControllerNew',
    41: 'Android',
    42: 'IOS',
    43: 'IPADOS'
  };

  return (
    <div className="ignoreOverride d-in-f">
      {!isEmpty(row?.original?.iconClass) ? (
        <SVGIcon name={row?.original?.iconClass} size={iconSize || 'lg'} />
      ) : (
        <SVGIcon
          name={iconMap[row?.original?.classId]}
          size={iconSize || 'lg'}
        />
      )}
    </div>
  );
}

export default AssetIconCell;
